import {
  USER_DETAILS_REQUEST, USER_DETAILS_SUCCESS, USER_DETAILS_FAILURE,
  DISMISS_ERROR
} from '../actions/account'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_REQUEST, LOGOUT_FAILURE, LOGOUT_SUCCESS } from '../actions/logout'

const INITIAL_STATE = {
  isReady: false,
  isLoading: false,
  error: false,
  errorMessage: '',
  username: '',
  firstName: '',
  lastName: '',
  email: '',
  thumbnail: '',
  isLoggingOut: false
}

const accountReducer = (state = INITIAL_STATE, action) => {
  switch(action.type) {

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE
      }

    case USER_DETAILS_REQUEST:
      return {
        ...state,
        isReady: false,
        isLoading: true,
        error: false,
        errorMessage: ''
      }
    case USER_DETAILS_SUCCESS:
      return {
        ...state,
        isReady: true,
        isLoading: false,
        error: false,
        errorMessage: '',
        username: action.payload.username,
        email: action.payload.email,
        firstName: action.payload.firstname,
        lastName: action.payload.lastname,
        thumbnail: action.payload.img.small
      }
    case USER_DETAILS_FAILURE:
      return {
        ...state,
        isReady: true,
        isLoading: false,
        error: true,
        errorMessage: action.payload.message
      }

    case LOGOUT_REQUEST:
      return {
        ...state,
        isLoggingOut: true
      }

    case LOGOUT_FAILURE:
      return {
        ...state,
        isLoggingOut: false
      }

    default:
      return state
  }
}

export default accountReducer
